export default "__VITE_ASSET__C8x8$Kqk__"